import conversationTypes from './conversations.types';

export const INITIAL_STATE = {
  conversations: {
    loading: false,
    data: [],
  },
  conversationsCount: null,
  users: {
    byId: {
      '5433243fsdf43': {
        fullName: 'لورم ايپسوم',
        sinceLastMessage: 'هم اكنون',
        lastMessage:
          'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.',
        unreadMessageCount: 3,
        imageUrl: 'https://randomuser.me/api/portraits/men/26.jpg',
        isOnline: true,
      },
      gflkdhgkfdhskf: {
        fullName: 'لورم ايپسوم',
        sinceLastMessage: '2 دقيقه',
        lastMessage: 'فايل ويدئويی',
        unreadMessageCount: 25,
        imageUrl: 'https://randomuser.me/api/portraits/men/54.jpg',
        isOnline: true,
      },
      flsdkkfdgkdfjg: {
        fullName: 'كاربر 123',
        sinceLastMessage: 'هم اكنون',
        lastMessage: 'سلام وقت بخير',
        unreadMessageCount: 0,
        imageUrl: 'https://randomuser.me/api/portraits/men/67.jpg',
        isOnline: false,
      },
      kjfds534j5kkfdgkdfjg: {
        fullName: 'لورم ايپسوم',
        sinceLastMessage: '2 هفته',
        lastMessage: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت',
        unreadMessageCount: 0,
        imageUrl: 'https://randomuser.me/api/portraits/men/47.jpg',
        isOnline: false,
      },
      flksdjjh53jlgdk4: {
        fullName: 'كاربر 234235',
        sinceLastMessage: '1 روز',
        lastMessage: 'فايل تصويری',
        unreadMessageCount: 0,
        imageUrl: '',
        isOnline: false,
      },
      flkjsdlfsdjh: {
        fullName: 'لورم ايپسوم',
        sinceLastMessage: '2 ماه',
        lastMessage: 'لطفا در داشبورد به بخش تنظیمات ادمین مراجعه فرمایید.',
        unreadMessageCount: 0,
        imageUrl: 'https://randomuser.me/api/portraits/men/98.jpg',
        isOnline: false,
      },
      flkjsdfsdfalfsdjh: {
        fullName: 'كاربر 7684563',
        sinceLastMessage: 'هم اكنون',
        lastMessage: 'يه سوال ديگه داشتم خدمتتون؟',
        unreadMessageCount: 0,
        imageUrl: '',
        isOnline: true,
      },
      gdffsdfalfsdjh: {
        fullName: 'كاربر 098',
        sinceLastMessage: 'هم اكنون',
        lastMessage: 'سلام وقت بخير',
        unreadMessageCount: 1,
        imageUrl: 'https://randomuser.me/api/portraits/men/19.jpg',
        isOnline: true,
      },
      flkjsdlfsfdsdjh: {
        fullName: 'كاربر 86875',
        sinceLastMessage: '2 روز',
        lastMessage: 'سلام وقت بخير',
        unreadMessageCount: 0,
        imageUrl: 'https://randomuser.me/api/portraits/women/23.jpg',
        isOnline: false,
      },
    },
  },
  agentStartedConversationsCount: 0,
  chats: {
    loading: false,
    status : "none", // "ready" | "waiting" | "none" 
    data: [],
  },
};

const conversationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // show loading while fetching data
    case conversationTypes.LOADING_CONVERSATIONS:
      return {
        ...state,
        conversations: {
          loading: true,
          data: state.conversations.data,
        },
      };

    case conversationTypes.LOADING_CHATS:
      return {
        ...state,
        chats: {
          loading: action.payload,
          data: state.chats.data,
          status : state.chats.status
        },
      };

    //  set fetched data in store
    case conversationTypes.SET_CONVERSATIONS:
      return {
        ...state,
        conversations: {
          loading: false,
          data: action.payload,
        },
      };

    case conversationTypes.SET_CONVERSATIONS_COUNT:
      return {
        ...state,
        conversationsCount: action.payload,
      };

    case conversationTypes.SET_AGENT_STARTED_CONVERSATIONS_COUNT:
      return {
        ...state,
        agentStartedConversationsCount: action.payload,
      };

    case conversationTypes.SET_CHATS:
      return {
        ...state,
        chats: {
          loading: false,
          data: action.payload.chats,
          status : action.payload.status
        },
      };

    default:
      return state;
  }
};

export default conversationsReducer;
